import React, { Component } from 'react';
import feedData from "../feedData.json";
import GeneralPostComponent from '../components/Posts/GeneralPostComponent';
import { Link } from 'react-router-dom';

class GeneralFeed extends Component {
    state = {
      posts: [],
      isLoading: true,
      allPostsFetched: false,
      comments: {},
      newComments: {},
    };
  
    componentDidMount() {
      console.log("Component mounted");
      console.log("feedData:", feedData);
      this.setState({ posts: feedData }, () => {
        console.log("State set:", this.state.posts);
        // Set isLoading to false after the posts are rendered
        this.setState({ isLoading: false });
      });
    }
  
    componentDidUpdate(prevProps, prevState) {
      // Check if isLoading is true and the posts have been set
      if (this.state.isLoading && this.state.posts.length > 0) {
        // Set isLoading to false after the posts are rendered
        this.setState({ isLoading: false });
      }
    }
  
    render() {
      console.log("Rendering...");
      const { posts, isLoading, allPostsFetched, comments, newComments } = this.state;
      const { currentUser } = this.props;
  
      return (
        <div className="w-4/5 mx-auto m-10">

          <div className="post-container">
            {posts.map((post, index) => (
              <div key={post.id} className={`mb-8 ${index !== posts.length - 1 ? 'pb-8 border-b' : ''}`}>
                {/* Render each post using the GeneralPostComponent */}
                <GeneralPostComponent post={post} />
              </div>
            ))}
            {isLoading && <p>Loading...</p>}
            {allPostsFetched && <p>No more posts to show</p>}
          </div>

            {/* Render section that says something like
            "to see more, create an account!" */}
            <div className="flex justify-center mt-8">
                <p className="text-lg">
                    To see more posts, 
                    <Link to="/sign_in" className="text-blue-500">
                    create an account!
                    </Link>
                </p>
            
            </div>

        </div>
      );
    }
  }
  
  export default GeneralFeed;
